export const supportedLocales = ['zh', 'en'];

export function getRouteLang(route) {
  const lang = route?.params?.lang || route?.query?.lang || sessionStorage.pcMicroSiteEditLang;
  return supportedLocales.includes(lang) ? lang : 'zh';
}

export function getRouteEventId(route) {
  return route?.params?.event_id || route?.query?.event_id || JSON.parse(localStorage.getItem('event_id') || 'null');
}

export function getCanonicalPath(route, path = '/') {
  const lang = getRouteLang(route);
  const eventId = getRouteEventId(route);
  if (!eventId) return path;

  const isDraft = isDraftRoute(route);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const suffix = normalizedPath === '/' ? '' : normalizedPath;
  return `${isDraft ? '/draft' : ''}/${lang}/${eventId}${suffix}`;
}

export function getRouteContentPath(route) {
  const path = route?.path || '/';
  const withoutDraft = path.replace(/^\/draft/, '') || '/';
  return withoutDraft.replace(/^\/(zh|en)\/\d+/, '') || '/';
}

export function isDraftRoute(route) {
  if (route?.path) return route.path.startsWith('/draft');
  return sessionStorage.pcMicroStationMode === 'draft';
}

export function getWebsiteRouteUrl(section, route, lang = getRouteLang(route), eventId = getRouteEventId(route)) {
  const draftPath = isDraftRoute(route) ? '/draft' : '';
  return `https://website.iceriverbj.com/${section}${draftPath}/${lang}/${eventId}`;
}
